import { useReduxState } from 'hooks';
import { Filters } from 'components/common/filter';

interface Props {
  filterId: string;
}

const CalendarEventParticipantsAttributeFilter = ({ filterId }: Props) => {
  const {
    language,
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  const productUserCustomAttributeFilters = calendarEvent.userAttributes?.map(
    (attribute, attributeIndex) => {
      const { max, min, type } = attribute;

      const filterData: React.ComponentProps<
        typeof Filters
      >['customFilters'][0] = {
        allowMultiple: true,
        field: `userAttributes.${attribute.id}`,
        icon: 'tag',
        position: 4 + attributeIndex,
        title: attribute.titleTranslations?.[language] || attribute.title
      };

      if (type === 'Boolean') {
        filterData.items = [
          { label: messages.commonYes, value: 'true' },
          { label: messages.commonNo, value: 'false' },
          { label: messages.commonNotSet, value: 'not set' },
          {
            label: messages.userAttributesNoIncludingNotSet,
            value: 'no including not set'
          }
        ];
      } else if (type === 'Number') {
        filterData.itemsAll = {
          label: messages.groupsUserAttributesAny,
          value: 'anyValueAllowed'
        };
        filterData.items = Array.from(
          Array(Math.max(max - min + 1, 1)),
          (n, i) => ({
            label: `${i + min}`,
            value: `${i + min}`
          })
        );
        filterData.selectAllOnClick = true;
      } else if (type === 'ArrayWithOptions' || type === 'StringWithOptions') {
        filterData.itemsAll = {
          label: messages.groupsUserAttributesAny,
          value: 'anyValueAllowed'
        };
        filterData.items = attribute.options.map((option) => ({
          label: option,
          value: option
        }));
        filterData.selectAllOnClick = true;
      } else {
        // type is String, Array or Text
        filterData.input = true;
      }

      return filterData;
    }
  );

  return (
    <div className="filters">
      <Filters
        customFilters={productUserCustomAttributeFilters}
        filterId={filterId}
        filters={{}}
      />
    </div>
  );
};

export default CalendarEventParticipantsAttributeFilter;
